import isNil from 'lodash/isNil';


function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('')
    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
    .join(''));
  return JSON.parse(jsonPayload);
}

/**
 * Whether a token whose expiry timestamp (ms epoch) is `expiredAt` counts as
 * expired: a missing timestamp is treated as expired, otherwise it is expired
 * once it falls within `buffer` ms of now. Single source of truth for the
 * JWT-expiry check shared by the storage hook and the auth provider.
 */
function isTokenExpired(expiredAt, buffer) {
  if (isNil(expiredAt)) {
    return true;
  }
  return (expiredAt - Date.now()) < buffer;
}


export { isTokenExpired, parseJwt };
